import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {HiOutlineClipboard, HiOutlineClipboardCheck} from 'react-icons/hi';
import {toast} from 'sonner';
import axios from 'axios';
import Swoosh from "@/assets/Assets/Pngs/swoosh.png";

const PaymentSuccessPopup = () => {
    const navigate = useNavigate();
    const [sessionCode, setSessionCode] = useState('');
    const [error, setError] = useState('');
    const [copied, setCopied] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const storedEmail = sessionStorage.getItem('mentra_payment_email');
        if (!storedEmail) return;

        setLoading(true);

        const fetchSessionCode = async () => {
            try {
                const response = await axios.get(`${import.meta.env.VITE_BASE_API_URL}/payment-code?email=${storedEmail}`);
                if (response.data.success) {
                    setSessionCode(response.data?.data?.session_code || '');
                    sessionStorage.removeItem('mentra_payment_email');
                } else {
                    setError(response.data.message || 'An error occurred.');
                }
            } catch (err) {
                setError(err.response?.data?.message || 'Network error occurred.');
            } finally {
                setLoading(false);
            }
        };

        const delayTimer = setTimeout(() => {
            fetchSessionCode();
        }, 11000);

        return () => clearTimeout(delayTimer);
    }, []);

    const handleDone = () => {
        navigate('/');
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(sessionCode);
        toast.info("Copied to clipboard!");
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="fixed inset-0 bg-[#578A80]/30 backdrop-blur-sm flex items-center justify-center z-10">
            <div
                style={{scrollbarWidth: 'none', msOverflowStyle: 'none'}}
                className="flex flex-col items-center bg-white py-8 px-4 sm:py-10 sm:px-6 rounded-[20px] w-[95%] max-w-[500px] shadow-lg"
            >
                {loading ? (
                    <div className="flex flex-col items-center justify-center py-16">
                        <div className="w-14 h-14 border-4 border-[#578A80] border-t-transparent rounded-full animate-spin mb-4"/>
                        <p className="text-sm text-gray-600 text-center">
                            Preparing your session details, please wait...
                        </p>
                    </div>
                ) : (
                    <>
                        {/* Header */}
                        <div className="text-center flex flex-col items-center w-full">
                            <img
                                alt="swoosh-icon"
                                src={Swoosh}
                                className="w-24 h-24 sm:w-32 sm:h-32 mb-2"
                            />
                            <h1 className="philosopher text-[18px] sm:text-[28px] font-bold text-[#191B1E] leading-tight text-center">
                                Congratulations! 🎉🎊
                            </h1>
                            <p className="text-[14px] sm:text-[16px] text-gray-600 mt-2 text-center">
                                Your payment was successful. Thank you for your purchase!
                            </p>
                        </div>

                        {/* Next Steps */}
                        <div className="mt-6 text-left w-full">
                            <p className="text-[15px] sm:text-[16px] font-medium text-[#191B1E] mb-2">Next Steps:</p>
                            <ol className="list-decimal list-inside text-gray-600 space-y-2 text-[14px] sm:text-[16px]">
                                <li>Check your email for further instructions</li>
                                <li>Please download the app to book your therapy session</li>
                                {sessionCode && (
                                    <li className="flex flex-col gap-1">
                                        <div className="flex items-center gap-2 flex-wrap">
                                            <p>Your session code:</p>
                                            <p className="font-extrabold text-[#578A80] break-all">{sessionCode}</p>
                                            <button
                                                onClick={handleCopy}
                                                title="Copy session code"
                                                className="text-[#578A80] hover:text-[#44685f] transition"
                                            >
                                                {copied ? (
                                                    <HiOutlineClipboardCheck className="w-5 h-5"/>
                                                ) : (
                                                    <HiOutlineClipboard className="w-5 h-5"/>
                                                )}
                                            </button>
                                        </div>
                                        <p className="text-gray-600 text-[14px] sm:text-[16px]">
                                            You can use this code to sign up in the mobile application.
                                        </p>
                                    </li>
                                )}
                                {error && (
                                    <li className="text-red-500 text-sm">Error: {error}</li>
                                )}
                            </ol>
                        </div>

                        {/* Done Button */}
                        <div className="w-full mt-8">
                            <button
                                type="button"
                                onClick={handleDone}
                                className="w-full bg-[#578A80] text-white py-4 sm:py-5 rounded-[30px] text-[15px] sm:text-[16px] font-semibold hover:bg-[#619288] transition-all duration-300"
                            >
                                Done
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default PaymentSuccessPopup;

// import React, {useEffect, useState} from 'react';
// import {useNavigate} from 'react-router-dom';
// import {HiOutlineClipboard, HiOutlineClipboardCheck} from 'react-icons/hi';
// import {toast} from 'sonner';
// import axios from 'axios';
// import Swoosh from "@/assets/Assets/Pngs/swoosh.png";
//
// const PaymentSuccessPopup = () => {
//     const navigate = useNavigate();
//     const [sessionCode, setSessionCode] = useState('');
//     const [error, setError] = useState('');
//     const [copied, setCopied] = useState(false);
//
//     useEffect(() => {
//         const fetchSessionCode = async () => {
//             const storedEmail = sessionStorage.getItem('mentra_payment_email');
//             if (!storedEmail) return;
//             try {
//                 const response = await axios.get(`${import.meta.env.VITE_BASE_API_URL}/payment-code?email=${storedEmail}`);
//                 if (response.data.success) {
//                     setSessionCode(response.data?.data?.session_code || '');
//                     sessionStorage.removeItem('mentra_payment_email');
//                 } else {
//                     setError(response.data.message || 'An error occurred.');
//                 }
//             } catch (err) {
//                 setError(err.response?.data?.message || 'Network error occurred.');
//             }
//         };
//
//         fetchSessionCode();
//     }, []);
//
//     const handleDone = () => {
//         navigate('/');
//     };
//
//     const handleCopy = () => {
//         navigator.clipboard.writeText(sessionCode);
//         toast.info("Copied to clipboard!");
//         setCopied(true);
//         setTimeout(() => setCopied(false), 2000);
//     };
//
//     return (
//         <div className="fixed inset-0 bg-[#578A80]/30 backdrop-blur-sm flex items-center justify-center z-10">
//             <div
//                 style={{scrollbarWidth: 'none', msOverflowStyle: 'none'}}
//                 className="flex flex-col items-center bg-white py-8 px-4 sm:py-10 sm:px-6 rounded-[20px] w-[95%] max-w-[500px] shadow-lg"
//             >
//                 {/* Header */}
//                 <div className="text-center flex flex-col items-center w-full">
//                     <img
//                         alt="swoosh-icon"
//                         src={Swoosh}
//                         className="w-24 h-24 sm:w-32 sm:h-32 mb-2"
//                     />
//
//                     <h1 className="philosopher text-[18px] sm:text-[28px] font-bold text-[#191B1E] leading-tight text-center">
//                         Congratulations! 🎉🎊
//                     </h1>
//                     <p className="text-[14px] sm:text-[16px] text-gray-600 mt-2 text-center">
//                         Your payment was successful. Thank you for your purchase!
//                     </p>
//                 </div>
//
//                 {/* Next Steps */}
//                 <div className="mt-6 text-left w-full">
//                     <p className="text-[15px] sm:text-[16px] font-medium text-[#191B1E] mb-2">Next Steps:</p>
//                     <ol className="list-decimal list-inside text-gray-600 space-y-2 text-[14px] sm:text-[16px]">
//                         <li>Check your email for further instructions</li>
//                         <li>Please download the app to book your therapy session</li>
//                         {sessionCode && (
//                             <li className="flex flex-col gap-1">
//                                 <div className="flex items-center gap-2 flex-wrap">
//                                     <p>Your session code:</p>
//                                     <p className="font-extrabold text-[#578A80] break-all">{sessionCode}</p>
//                                     <button
//                                         onClick={handleCopy}
//                                         title="Copy session code"
//                                         className="text-[#578A80] hover:text-[#44685f] transition"
//                                     >
//                                         {copied ? (
//                                             <HiOutlineClipboardCheck className="w-5 h-5"/>
//                                         ) : (
//                                             <HiOutlineClipboard className="w-5 h-5"/>
//                                         )}
//                                     </button>
//                                 </div>
//                                 <p className="text-gray-600 text-[14px] sm:text-[16px]">
//                                     You can use this code to sign up in the mobile application.
//                                 </p>
//                             </li>
//                         )}
//                         {error && (
//                             <li className="text-red-500 text-sm">Error: {error}</li>
//                         )}
//                     </ol>
//                 </div>
//
//                 {/* Done Button */}
//                 <div className="w-full mt-8">
//                     <button
//                         type="button"
//                         onClick={handleDone}
//                         className="w-full bg-[#578A80] text-white py-4 sm:py-5 rounded-[30px] text-[15px] sm:text-[16px] font-semibold hover:bg-[#619288] transition-all duration-300"
//                     >
//                         Done
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };
//
// export default PaymentSuccessPopup;
